import { ExternalLink } from "lucide-react";
import { DASHBOARD, estimateCost, money } from "@/lib/jammableApi";
import { fmtClock } from "@/lib/studioApi";

/** The price before anything starts: estimate for this audio + your Jammable balance. */
export default function CostBox({ duration, label, status }) {
  const est = estimateCost(duration);
  const low = status?.balance != null && status.balance < est;
  return (
    <div data-testid="jam-cost" className={`rounded-2xl border p-3 text-[13px] ${low ? "border-amber-300/40 bg-amber-500/[0.1]" : "border-white/[0.08] bg-white/[0.03]"}`}>
      <p>About <span data-testid="jam-cost-estimate" className="font-display text-[16px] font-semibold text-fuchsia-100">{money(est)}</span> for {label} ({fmtClock(duration)})</p>
      <p className="mt-0.5 text-[12px] text-white/55">
        Your Jammable balance: <span data-testid="jam-balance" className="font-mono text-white/80">{status?.balance_error ? "couldn't check" : money(status?.balance)}</span>
        {" "}· $0.25 a minute, billed by the second, $0.10 minimum. Failed jobs are free.
      </p>
      {low ? (
        <p data-testid="jam-balance-low" className="mt-1.5 text-[12px] text-amber-100">
          Your balance is lower than this job. <a href={DASHBOARD} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 underline">Top it up <ExternalLink className="h-3 w-3" /></a>
        </p>
      ) : null}
    </div>
  );
}
